import React, { useState, useEffect, useRef } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { ICON_SAVE, ICON_CANCEL } from '../../extras/icons';
import { useDispatch, useSelector } from 'react-redux';
import { saveAudienceCategoriesAction, updateAudienceCategoriesAction, listAudienceCategoriesAction } from '../../../actions/audienceCategoriesActions';
import { Formik } from 'formik';
import ButtonSpinner from '../../layout/ButtonSpinner';
import * as yup from 'yup';


const AudienceCategoryForm = props => {
    //Tomo los props
    const { show, handleClose } = props;
    //Genero los refs
    const refDescription = useRef();
    //Datos iniciales
    const initialData = {
        descripcion: '',
        grupo: ''
    }
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Traigo el store de persona tipos
    const audienceCategoriesLoading = useSelector( state => state.audienceCategories.loadingSave );
    const isEdit = useSelector( state => state.audienceCategories.isEdit );
    const audienceCategorySelected = useSelector( state => state.audienceCategories.audienceCategorySelected );
    const audienceCategories = useSelector( state => state.audienceCategories.audienceCategories );
    //Inicializo el state local
    const [ audienceCategory, setAudienceCategory ] = useState(initialData);
    const [ groups, setGroups ] = useState(null);
    //Modifico según el cambio
    useEffect(() => {
        //Me fijo si es edición
        if(isEdit && audienceCategorySelected){
            setAudienceCategory({
                ...audienceCategorySelected,
                grupo: audienceCategorySelected.grupo ? audienceCategorySelected.grupo.id : ''
            });
        }else{
            setAudienceCategory(initialData);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isEdit, audienceCategorySelected, show])
    useEffect(() => {
        //Si cambian los datos, asigno los grupos
        if(audienceCategories){
            //Seteo los grupos
            setGroups([
                ...audienceCategories.filter(ac => ac.grupo===null && ac.activo===1)
            ])
        }
    }, [audienceCategories]);
    //Manejo el guardado
    const handleSave = values => {
        //Armo el objeto de datos
        let data = {
            descripcion: values.descripcion,
            grupo: {
                id: values.grupo
            },
            activo: 1
        }
        //Verifico si es edición o alta
        if(audienceCategory.id){
            //Agrego el ID
            data = {
                id: audienceCategory.id,
                ...data
            }
            //Es edición
            dispatch( updateAudienceCategoriesAction(data, handleCloseForm) );
        }else{
            //Es creación
            dispatch( saveAudienceCategoriesAction(data, handleCloseForm) );
        }
    }
    //Manejo cuando se muestra
    const handleOnShow = e => {
        //Me fijo si está cargado
        if(!audienceCategories){
            dispatch( listAudienceCategoriesAction() );
        }else{
            //Seteo los grupos
            setGroups([
                ...audienceCategories.filter(ac => ac.grupo===null && ac.activo===1)
            ])
        }
        //Pongo el foco en el primer campo
        refDescription.current.focus();
    }
    //Manejo cierre de la ventana
    const handleCloseForm = e => {
        //Reinicio datos
        setAudienceCategory(initialData);
        //Cierro
        handleClose();
    }
    //Esquema de validación
    const validationSchema = yup.object({
        descripcion: yup.string().required(),
        grupo: yup.number().required()
    });
    //Renderizo
    return (
        <Modal show={show} onHide={handleCloseForm} onShow={handleOnShow} aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    Audiencia Categoría&nbsp;
                    <small><strong>{ isEdit ? 'Editar' : 'Nuevo' } Registro</strong></small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{ ...audienceCategory }}
                onSubmit={ values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    values,
                    errors,
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <Form.Group className="col-md-12">
                                    <label htmlFor="descripcion">Descripción</label>
                                    <Form.Control
                                        id="descripcion"
                                        className="form-control" 
                                        autoFocus 
                                        name="descripcion" 
                                        type="text" 
                                        value={ values.descripcion }
                                        onChange={handleChange}
                                        ref={refDescription}
                                        isInvalid={!!errors.descripcion}
                                        disabled={ audienceCategoriesLoading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.descripcion }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-12">
                                    <label htmlFor="grupo">Grupo</label>
                                    <Form.Control
                                        as="select"
                                        id="grupo"
                                        className="form-control"  
                                        name="grupo" 
                                        type="text" 
                                        value={ values.grupo }
                                        onChange={handleChange}
                                        isInvalid={!!errors.grupo}
                                        disabled={ audienceCategoriesLoading }
                                    >
                                        <option value="">Seleccione el Grupo</option>
                                        {
                                            groups.map(group => (
                                                <option value={group.id} key={`amg${group.id}`}>
                                                    { group.descripcion }
                                                </option>
                                            ))
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.grupo }
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {
                                audienceCategoriesLoading ? (
                                    <ButtonSpinner />
                                ) : (
                                    <Button variant="success" type="submit" disabled={ audienceCategoriesLoading }>
                                        <ICON_SAVE /> <strong>{ isEdit ? 'ACTUALIZAR' : 'GUARDAR' }</strong>
                                    </Button>
                                )
                            }
                            <Button variant="secondary" onClick={handleCloseForm} disabled={ audienceCategoriesLoading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default AudienceCategoryForm;